import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'

//Default olarak dosyayi public>locales altinda en , tr olarak klasorler icinde translation.json dosyalarindan alir.
const availableLanguages = ['en', 'tr']

i18n.use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        //Default dil buradan atanir.
        lng:'tr',
        detection: {
            checkWhitelist: true
        },
        debug: false,
        whitelist: availableLanguages,
        interpolation: {
            escapeValue: false 
        },
        react: {
            useSuspense: false,
          }
    })

export default i18n
